import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getPlansForBusiness, adminAssignPlan } from '../../actions/homeAction';

const LIST_ROUTE = {
  Garage: '/ServiceProviders/Garage',
  SpareParts: '/ServiceProviders/SpareParts',
  CarDealers: '/ServiceProviders/CarDealers',
  RentCar: '/ServiceProviders/RentCar',
  Taxi: '/ServiceProviders/Taxi',
  CarWash: '/ServiceProviders/CarWash',
  CarTowing: '/ServiceProviders/CarTowing',
  CarInsurance: '/ServiceProviders/CarInsurance',
  DrivingSchool: '/ServiceProviders/DrivingSchool',
  CarProtection: '/ServiceProviders/CarProtection',
  CarConditioning: '/ServiceProviders/CarConditioning',
  QuickService: '/ServiceProviders/QuickService',
};

const AssignPlan = () => {
  const dispatch = useDispatch();
  const { type, businessId } = useParams();
  const [selected, setSelected] = useState('');
  const backTo = LIST_ROUTE[type] || '/';

  useEffect(() => {
    if (businessId) dispatch(getPlansForBusiness(businessId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessId]);

  const res = useSelector((state) => state.home.plansForBusiness);
  const plans = res?.response?.data || res?.data || [];

  const onAssign = () => {
    if (!selected) return;
    dispatch(
      adminAssignPlan(businessId, selected, () => {
        window.location.href = '#' + backTo;
      })
    );
  };

  const card = {
    background: '#fff',
    borderRadius: 8,
    padding: '1.5rem',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    maxWidth: 720,
  };

  return (
    <div className="pcoded-inner-content">
      <div className="main-body">
        <div className="page-wrapper">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h4 style={{ fontWeight: 600 }}>Assign / Extend Plan</h4>
            <Link to={backTo} className="btn btn-sm btn-outline-dark">Back</Link>
          </div>

          <div style={card}>
            <p style={{ color: '#7b8aa5' }}>
              Select a plan to grant this {type} account. The duration is added on top of any remaining
              days, extending their membership and keeping the account active.
            </p>

            <div className="form-group" style={{ maxWidth: 460 }}>
              <label style={{ fontWeight: 600 }}>Plan</label>
              <select className="form-control" value={selected} onChange={(e) => setSelected(e.target.value)}>
                <option value="">Select a plan…</option>
                {plans.map((p) => (
                  <option key={p.advertisementPackId} value={p.advertisementPackId}>
                    {p.name} — {p.duration} day(s){p.amount != null ? ` · ${p.amount} KWD` : ''}
                  </option>
                ))}
              </select>
              {plans.length === 0 && (
                <small style={{ color: '#9aa7bd' }}>No plans found for this category.</small>
              )}
            </div>

            <button className="btn btn-inverse" disabled={!selected} onClick={onAssign}>
              Assign Plan
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignPlan;
